import * as Module from '/external-libraries/highcharts/12.4.0/highcharts.js';
import * as Accessibility from '/external-libraries/highcharts/12.4.0/modules/accessibility.js';
import Util from '../../util.js'
import DataVisualizationUtil from '../util.js'

export class AreaChart extends HTMLElement {

    #template = document.createElement('template');
    #templateMarkup = `
      <figure alt="Area chart"></figure>    
    `;

    #chartContainer;
    #chartData = '[]';
    #chartSettings = '{}';
    #stylesLoaded = false;
    #pendingRender = false;

    constructor() {
        super();

        this.attachShadow({mode: 'open'});

        this.addStyle = Util.addStyle;        
        this.getChartColors = DataVisualizationUtil.getChartColors;
        this.normalizeSeriesData = DataVisualizationUtil.normalizeSeriesData;
        this.combineNamesWithSeries = DataVisualizationUtil.combineNamesWithSeries;
        this.#template.innerHTML = this.#templateMarkup;
        this.shadowRoot.appendChild(this.#template.content.cloneNode(true));

        this.#chartContainer = this.shadowRoot.querySelectorAll('figure')[0];
        
        this.loadStylesWithPromise = Util.loadStylesWithPromise;
        this.loadStylesWithPromise([
            '/src/styles/neptune.css',
            '/src/components/dataVisualization/chart.css'
        ]).then(() => {
            this.#stylesLoaded = true;
            if (this.#pendingRender) {
                this.#renderChart();
            }
        });
    }

    static get observedAttributes() {
        return ['series', 'settings'];
    }

    connectedCallback() {
    }

    disconnectedCallback() {
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'series': {
                if ('' === newValue) {
                    return;
                }
                this.#chartData = newValue;
                break;
            }
            case 'settings': {
                if ('' === newValue) {
                    return;
                }
                this.#chartSettings = newValue;
                break;
            }
            default: {
                break;
            }
        }

        if (this.#stylesLoaded) {
            this.#renderChart(); 
        } else {
            this.#pendingRender = true;
        }
    }

    #renderChart() {
        setTimeout(() => {
            this.drawChart(this.#chartContainer, JSON.parse(this.#chartData), JSON.parse(this.#chartSettings));
            this.#pendingRender = false;
        }, 100);
    }

    drawChart(id, seriesData, chartSettings) {
        if ((undefined == seriesData) || ([] == seriesData)) {
            console.log('Neptune line chart: No data');
            return;
        }

        if ((undefined == chartSettings) || ({} == chartSettings)) {
            chartSettings = {};
        }

        seriesData = this.normalizeSeriesData(seriesData);

        if (undefined != chartSettings?.seriesNames) {
            seriesData = this.combineNamesWithSeries(chartSettings.seriesNames, seriesData);
        }

        return Highcharts.chart(id, {
            chart: {
                type: 'area'
            },
            colors: this.getChartColors(),
            title: {
                text: chartSettings?.title ?? ''
            },
            subtitle: {
                text: chartSettings?.subtitle ?? ''
            },
            xAxis: {
                categories: chartSettings?.categories,
                crosshair: true
            },
            yAxis: {
                title: {
                text: chartSettings.yAxisTitle ?? ''
                }
            },
            tooltip: {
                enabled: true
            },
            plotOptions: {
                series: {
                    label: {
                        enabled: false
                    }
                }
            },
            legend: {
                enabled: chartSettings.showLegend ?? false
            },
            series: seriesData
        });
    }
}

customElements.define('neptune-area-chart', AreaChart);
export default {AreaChart};